/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetence,
    LearningCompetenceFromJSON,
    LearningCompetenceFromJSONTyped,
    LearningCompetenceToJSON,
} from './LearningCompetence';

/**
 * 
 * @export
 * @interface UpdateStudyPlanInfoDTO
 */
export interface UpdateStudyPlanInfoDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyPlanInfoDTO
     */
    mission?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyPlanInfoDTO
     */
    objective?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyPlanInfoDTO
     */
    ocupationName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateStudyPlanInfoDTO
     */
    codCOR?: string | null;
    /**
     * 
     * @type {Array<LearningCompetence>}
     * @memberof UpdateStudyPlanInfoDTO
     */
    learningCompetences?: Array<LearningCompetence> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStudyPlanInfoDTO
     */
    keyCompetenceTemplateIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStudyPlanInfoDTO
     */
    greenCompetenceTemplateIds?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateStudyPlanInfoDTO
     */
    digitalCompetenceTemplateIds?: Array<string> | null;
}

export function UpdateStudyPlanInfoDTOFromJSON(json: any): UpdateStudyPlanInfoDTO {
    return UpdateStudyPlanInfoDTOFromJSONTyped(json, false);
}

export function UpdateStudyPlanInfoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateStudyPlanInfoDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mission': !exists(json, 'mission') ? undefined : json['mission'],
        'objective': !exists(json, 'objective') ? undefined : json['objective'],
        'ocupationName': !exists(json, 'ocupationName') ? undefined : json['ocupationName'],
        'codCOR': !exists(json, 'codCOR') ? undefined : json['codCOR'],
        'learningCompetences': !exists(json, 'learningCompetences') ? undefined : (json['learningCompetences'] === null ? null : (json['learningCompetences'] as Array<any>).map(LearningCompetenceFromJSON)),
        'keyCompetenceTemplateIds': !exists(json, 'keyCompetenceTemplateIds') ? undefined : json['keyCompetenceTemplateIds'],
        'greenCompetenceTemplateIds': !exists(json, 'greenCompetenceTemplateIds') ? undefined : json['greenCompetenceTemplateIds'],
        'digitalCompetenceTemplateIds': !exists(json, 'digitalCompetenceTemplateIds') ? undefined : json['digitalCompetenceTemplateIds'],
    };
}

export function UpdateStudyPlanInfoDTOToJSON(value?: UpdateStudyPlanInfoDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mission': value.mission,
        'objective': value.objective,
        'ocupationName': value.ocupationName,
        'codCOR': value.codCOR,
        'learningCompetences': value.learningCompetences === undefined ? undefined : (value.learningCompetences === null ? null : (value.learningCompetences as Array<any>).map(LearningCompetenceToJSON)),
        'keyCompetenceTemplateIds': value.keyCompetenceTemplateIds,
        'greenCompetenceTemplateIds': value.greenCompetenceTemplateIds,
        'digitalCompetenceTemplateIds': value.digitalCompetenceTemplateIds,
    };
}

